import { render, staticRenderFns } from "./ModalEditMessage.vue?vue&type=template&id=cd9913d4&"
import script from "./ModalEditMessage.vue?vue&type=script&lang=js&"
export * from "./ModalEditMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports